import type { FileKind } from './types';
import s from './files.module.css';

/** Màu chip loại tệp (PDF / Word / Excel…). */
export const KIND_CLS: Record<FileKind, string | undefined> = { PDF: s.kPdf, DOC: s.kDoc, XLS: s.kXls, PPT: s.kPpt, IMG: s.kImg, VID: s.kImg, FILE: s.kFile };
